
import { ViewEncapsulation, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Filter } from '../filters';

@Component({
  selector: 'cbre-default-filter-label-renderer',
  template: ` <div class="fx--h fx--ali-center">
    <label class="form-field__label" [attr.for]="filter().key">{{ filter().value }}</label>
  </div>`,
  imports: [],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultFilterLabelRendererComponent {
  readonly filter = input<Filter>();
}
